import angular from 'angular';

import { FEEDBACK_URL, MODAL_FREQUENCY_DAYS, MIN_SHOPIFY_EXPERIENCE_DAYS } from './constants';

export default class RateService {
  constructor(
    Restangular,
    Authentication,
    Utils,
    PersonaCollection,
    IntegrationService,
    $compile,
    $rootScope,
    $http,
    $timeout,
    $uibModal,
    $document
  ) {
    'ngInject';

    Object.assign(this, {
      Restangular,
      Authentication,
      Utils,
      PersonaCollection,
      IntegrationService,
      $compile,
      $rootScope,
      $http,
      $timeout,
      $uibModal,
      $document,
    });
  }

  async triggerRateModal() {
    const canDisplayModal = await this.canDisplayRateModal();
    if (canDisplayModal) {
      await this.$timeout(3000);
      this.openRateModal();
      this.markRateDataOption('lastDisplayDate');
    }
  }

  async canDisplayRateModal() {
    const { isAdmin } = this.Authentication.user;

    if (!isAdmin) {
      return false;
    }

    const { lastDisplayDate, shopifyReviewed, feedbackSent } = this.getRateData();
    if (shopifyReviewed || feedbackSent) {
      return false;
    }
    const daysSinceLastDisplay = (new Date() - new Date(lastDisplayDate)) / 1000 / 3600 / 24;
    if (daysSinceLastDisplay < MODAL_FREQUENCY_DAYS) {
      return false;
    }

    const shopify = await this.IntegrationService.getIntegrationByPlatform('shopify');
    if (!shopify || !shopify.enabled) {
      return false;
    }

    const daysSinceShopifyIntegrationStarted =
      (new Date() - new Date(shopify.created)) / 1000 / 3600 / 24;
    return daysSinceShopifyIntegrationStarted >= MIN_SHOPIFY_EXPERIENCE_DAYS;
  }

  openRateModal() {
    if (this.modalVisible) {
      return;
    }

    this.modal = this.$compile('<rate-modal></rate-modal>')(this.$rootScope.$new());
    angular.element(this.$document[0].body).append(this.modal);
    this.modalVisible = true;
  }

  closeRateModal(rating) {
    this.modal?.remove();
    this.modalVisible = false;

    if (!this.feedbackSent) {
      this.sendFeedback({ rating, message: '** Rate modal closed **' });
    }
  }

  submitFeedback(feedback) {
    if (feedback?.message) {
      this.sendFeedback(feedback);
    }

    this.markRateDataOption('feedbackSent');
  }

  sendFeedback(feedback) {
    this.feedbackSent = true;

    return this.$http({
      method: 'POST',
      url: FEEDBACK_URL,
      data: [
        `Name=${encodeURIComponent(this.Authentication.user.fullname)}`,
        `Email=${encodeURIComponent(this.Authentication.user.email)}`,
        `Opinion=${encodeURIComponent(feedback.message || '')}`,
        `Rating=${encodeURIComponent(feedback.rating || '-')}`,
        `Org=${encodeURIComponent(this.Authentication.user.org.name)}`,
        `OrgId=${encodeURIComponent(this.Authentication.user.org.id)}`,
        `UserId=${encodeURIComponent(this.Authentication.user.id)}`,
      ].join('&'),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  }

  getRateData() {
    return this.Authentication.user.settings.clientFlags.rate || {};
  }

  markRateDataOption(option) {
    this.Authentication.saveClientFlags({
      rate: {
        ...this.getRateData(),
        [option]: new Date(),
      },
    });
  }

  saveAppReviewed() {
    this.markRateDataOption('shopifyReviewed');
  }
}
